<template>
  <div style="width:100%;height:100%;" >
    <!--导航栏-->
     <div class="nav_father" v-if="pauseimg">
      <div class="nav ">
        <div class='logo'>
         <router-link to="/">
            <img src="../../../static/image/logo.png" alt="">
         </router-link>
      </div>
        <ul>
          <li v-for="(item,index) in nav" :key="index"  >
            <router-link :to="item.path" active-class="active"  >{{item.text}}</router-link>
          </li>
        </ul>
        <!--logo-->
      </div>
      
     </div>
    <!--轮播-->
  <el-carousel :interval=3000 :autoplay=true indicator-position  arrow="never" style="width:100%;margin:auto" :style="'height:' + curHeight" @change="change()">
    <el-carousel-item v-for="(item,index) in bannerList" :key="index" :style="'height:' + curHeight" style="width:100%;margin:auto">
       <div :style="'height:' + curHeight" style="margin:auto" >
         <img :src="item.images" alt="" style="object-fit:cover; width:100%;height:100%; vertical-align: top;" >      
     </div>
    </el-carousel-item>
  </el-carousel>
  <!--播放-->
      <div class="play">
          <img src="../../assets/play_03.png" alt="" @click="playing()" v-if=" pauseimg">
          <div class="close" @click="close()" v-if="guanbi"><img src="../../assets/close.png" alt=""></div>
          <video id="VD" :src="videoUrl" controls="controls" auto v-if="video" autoplay="autoplay" loop="loop">亲亲，这边建议您升级您的浏览器呢</video>
       </div>
   <!--报名入口-->
      <div id="FlAD" class="signup" v-if="pauseimg" @click="jump()">
         <img src="../../assets/entrance.png" alt="">
      </div>
  </div>
</template>
<script>
export default {

  name:'Home',
  data() {
    return {
      pauseimg:true,
      video:false,
      guanbi:false,
      value:0,
      curHeight:'0',
      videoUrl:'',
      bannerList:[
        {images:''},
        {images:''},
        {images:''},
        {images:''},
       
      ],
      nav:[
        {text:'走进崇艺',path:'/Enter'},
        {text:'儿童剧场',path:'/Children'},
        {text:'实时公告',path:'/Notice'},
        {text:'家长学校',path:'/School'},
        {text:'招生招聘',path:'/Recruit'},
        {text:'党团之家',path:'/Caucus'},
        {text:'联系我们',path:'/Contact'}
        
        ]
    }
  },
  methods:{
     jump(){
       this.$router.push({name:'Recruit',params:{value:0}})
     },
     change(){
      //  console.log(gfgf)
     },
     height() {
       //获取浏览器可视区域高度
      var h = document.documentElement.clientHeight || document.body.clientHeight;
      this.curHeight=h-.1+'px';
      // console.log(this.curHeight)
    },
    playing(){
      this.video=true;
      this.guanbi=true;
      this.pauseimg=false;
      // var V=document.getElementById("VD");
      // V.play();
    },
    close(){
        this.video=false;
        this.guanbi=false;
        this.pauseimg=true;
        var VD=document.getElementById("VD");
        VD.pause();
    }
  },
    created(){
     
      let isFirst = window.localStorage.getItem('isFirst')
      if (isFirst == 1) {
        location.reload()
        window.localStorage.removeItem('isFirst')
      }
      console.log(window)
        setInterval(()=>{this.height()},50);
        //   window.onresize = () => {
        //     return (() => {
        //         var h = document.documentElement.clientHeight || document.body.clientHeight;
        //         return this.curHeight=h-.1+'px';
        //     })()
        //  }
        this.$http.post('/api/index/getList', {
          }).then( (res)=> {
          // console.log(res.data.data.lists)
            var code=res.data.code;
            if(code===0){
            this.bannerList=res.data.data.lists
            }
          }).catch(function (error) {
        //  console.log(error);
     });
     this.$http.post('/api/index/getVideo', {

          }).then( (res)=> {
          // console.log(res.data.data.videoUrl)
            var code=res.data.code;
            if(code===0){
              this.videoUrl=res.data.data.videoUrl
            }
          }).catch(function (error) {
        //  console.log(error);
     });
    },
    destroyed () {
      console.log('离开')
      window.localStorage.setItem('isFirst', 1)
    }
}
</script>
<style scoped>
  body{
  position: relative;

  }

.close{
  z-index: 600;
  position:absolute !important;
  top: 8%;
  right: 8%;
}
.play .close>img{
  width: 30px;
  height: 30px;
}
.close:hover{
  cursor: pointer;
}
 video{
  position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background: #000;
    z-index: 500;
} 
.play img{
  width:100px;
  height: 100px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform:translate(-50%, -50%); 
  z-index:1000;
}
.signup,.signup img{
  width: 164px;
  height: 146px;
}
.signup img:hover{
  cursor: pointer;
}
.signup{
 position: fixed;
  top:42%;
  right: 54px;
  z-index:99999;
}
.nav{
  
  width: 1200px;
  /* height: 4vw; */
  height: 55px;
  background-color: white;
  /* width: 100%; */
  border-radius: 50px;
  /* position:absolute; */
}
.nav_father{
  width: 1200px;
  margin: 30px auto;
  position: fixed;
  left: 50%;
  transform: translate(-50%);
  z-index: 1000;
}
.nav ul{
  width: 890px;
   /* min-width: 600px; */
   /* width: 48vw; */
   display: flex;
  justify-content: space-around;
  float: left;
  /* margin-left: 19%; */
  margin: 0px auto;
  /* position: absolute;
  left: 23%; */
 
} 
.nav ul li{
   
  list-style: none;
  font-weight: bolder;
  line-height: 55px;
  width: 105px;
}

.nav ul li a {
  
  text-decoration: none;
  color: rgb(81, 81, 81);
  /* font-size: 0.89vw; */
  font-size: 16px;
}
.nav ul li:hover{
  cursor: pointer;
}
 .logo{
   width:266px;
   /* height: 13.49vh; */
   /* max-width: 266px; */
   /* max-height: 82px; */
   /* height: 5.125rem; */
  object-fit: cover;
  float: left;
  margin-top: -14px;
  /* position: absolute;
  top: 52%;
  transform: translateY(-56%) */
  /* left: -1%; */
 
 }
 .logo img{
   width: 100%;
   height: 100%;
   object-fit:contain;
   text-decoration: none;
}
.logo a{
  text-decoration: none;
}
</style>




// WEBPACK FOOTER //
// src/pages/pcPages/Home.vue